import React, { Component } from "react";
import PropTypes from "prop-types";

import Lottie from "react-lottie";

const propTypes = {
    animation: PropTypes.string.isRequired,
    selected: PropTypes.bool
};

class LottieAnimation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            paused: !props.selected,
            stopAtTheEnd: false,
            animationData: JSON.parse(props.animation)
        };
        this.onLoopComplete = this.onLoopComplete.bind(this);
    }
    componentDidMount() {
        // there's a bug where if you go to the ModelForm screen, then go back then next (or next then back)
        // the animation plays even though the flag paused is true
        // I found that forcing an update like that redraws the Lottie and stops the animation.
        setTimeout(() => this.forceUpdate(), 1);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.selected === null && this.props.selected !== null) {
            this.setState({ paused: !this.props.selected });
            return;
        }

        if (prevProps.selected !== this.props.selected) {
            if (this.props.selected) {
                this.setState({ paused: false, stopAtTheEnd: false });
            } else {
                this.setState({ stopAtTheEnd: true });
            }
            return;
        }
    }

    onLoopComplete() {
        if (this.state.stopAtTheEnd) {
            this.setState({ paused: true, stopAtTheEnd: false });
        }
    }

    render() {
        const { paused, animationData } = this.state;
        
        return (
            <Lottie
                options={{
                    loop: true,
                    autoplay: true,
                    animationData: animationData
                }}
                isClickToPauseDisabled
                isPaused={paused}
                eventListeners={[{ eventName: "loopComplete", callback: this.onLoopComplete }]}
            />
        );
    }
}

LottieAnimation.propTypes = propTypes;

LottieAnimation.defaultProps = {
    selected: null
};

export default LottieAnimation;



// WEBPACK FOOTER //
// ./src/components/LottieAnimation.js